import getConfig from 'next/config';
import React, { useEffect } from 'react';

import { Avatar } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import styles from './user-avatar.module.scss';

type TProps = {
  userId: number;
  isRepresentative?: boolean;
  isBankAnswer?: boolean;
  logo?: string;
};

const { avatarURLPrefix } = getConfig().publicRuntimeConfig;

export const UserAvatar: React.FC<TProps> = ({ userId, isRepresentative = false, isBankAnswer = false, logo }) => {
  const [hasAvatar, setAvatarState] = useBoolean(false);

  useEffect(() => {
    const fetchUserAvatar = async () => {
      try {
        const result = await fetch(`${avatarURLPrefix}/${userId}.svg`);

        const data = await result.text();
        if (!data.includes('control-profile')) {
          setAvatarState.on();
        }
      } catch (e) {
        setAvatarState.off();
      }
    };

    fetchUserAvatar();
  }, [setAvatarState, userId]);

  if (isBankAnswer) return <Avatar size={36} src={logo} />;

  if (isRepresentative && Boolean(logo)) {
    if (hasAvatar) {
      return (
        <div className={styles.avatarWrapper}>
          <Avatar size={36} src={`${avatarURLPrefix}/${userId || 0}-xs.svg`} />
          <img src={logo} className={styles.logo} />
        </div>
      );
    }

    return <Avatar size={36} src={logo} />;
  }

  return <Avatar size={36} src={`${avatarURLPrefix}/${userId || 0}-xs.svg`} />;
};
